//Map
import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, GoogleMap, LoadScript, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { Button, Card, Col, Descriptions, Input, Modal, Row, Select, Space, Typography, message, notification } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import axios from "axios";
import { GET_ADD_COORDINATES } from "../API/apiUrls";
import styled from "styled-components";

const { Title, Text } = Typography;
const { Option } = Select;

// ขนาดของ Map
const containerStyle = {
    width: "100%",
    height: "500px",
};

// พิกัดเริ่มต้น (ตัวอย่าง: ขอนแก่น)
const defaultCenter = { lat: 16.460080198821046, lng: 102.83231745521805 };

function Map({ open, close, onSave, isLoaded, loadError, dataSendForMap }) {
    const mapRef = useRef(null);
    const inputRef = useRef(null);
    const [api, contextHolder] = notification.useNotification();
    const [loading, setLoading] = useState(true)
    const [markerName, setMarkerName] = useState(
        dataSendForMap ? // ถ้ามีข้อมูลจากก้อนที่ส่งมา
            {
                ...dataSendForMap,
                lat: parseFloat(dataSendForMap?.lat),
                lng: parseFloat(dataSendForMap?.lng),

            }
            : // ถ้าไม่มี ให้ใช้ defaultCenter
            {
                ...defaultCenter

            }
    );
    const [markerPosition, setMarkerPosition] = useState({ // เลือกโดยการคลิ๊ก
        lat: markerName?.lat || defaultCenter.lat,
        lng: markerName?.lng || defaultCenter.lng,
    });
    const [optionsSelect, setOptionSelect] = useState([])
    const [dataParams, setDataParams] = useState({})

    // console.log("markerName", markerName);
    console.log("dataSendForMap", dataSendForMap);
    // console.log("markerPosition", markerPosition);
    // console.log("optionsSelect", optionsSelect);
    // console.log("dataParams", dataParams);

    if (loadError) return <div>❌ โหลด Google Maps ไม่สำเร็จ</div>;
    if (!isLoaded) return <div>⏳ กำลังโหลดแผนที่...</div>;

    const mapaddress = (lat, lng) => {
        optionsSelect?.map((map, idx) => {
        })
    }
    // input for Search
    const StyledSearch = styled(Input.Search)`
            .ant-input {
                height: 40px;
                line-height: 40px;
            }
    
            .ant-input-search-button {
                height: 40px;
            }
        `;

    // ปิด Modal
    const handleClose = () => close(false);

    // ค้นหาที่อยู่ด้วย Geocoder
    // ค้นหาที่อยู่ด้วย Geocoder
    const handleSearch = (address) => {
        if (!address || !mapRef.current) return;

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
            { address, region: "TH" }, // ใส่ region=TH บังคับให้เป็นประเทศไทย
            (results, status) => {
                if (status === "OK" && results[0]) {
                    const location = results[0].geometry.location;
                    const newPos = { lat: location.lat(), lng: location.lng() };

                    console.log("newPos", newPos);
                    console.log("location", location);
                    console.log("results[0]", results[0]);

                    setMarkerName({
                        ...markerName,
                        lat: newPos.lat,
                        lng: newPos.lng,
                        address: results[0].formatted_address, // ที่อยู่ภาษาไทย
                    });

                    mapRef.current.panTo(newPos);
                    mapRef.current.setZoom(15);
                } else {
                    alert("ไม่พบที่อยู่ กรุณาลองใหม่");
                }
            }
        );
    };

    // เมื่อกดบันทึก ส่งข้อมูลกลับ
    const handleSave = async () => {
        setLoading(true)
        if (!dataSendForMap?.landId) {
            message.error("ไม่พบ landId กรุณาตรวจสอบข้อมูลก่อนบันทึก");
            return;
        }
        const params = {
            landId: dataSendForMap ? dataSendForMap?.landId : "",
            nameMap: markerName?.address,
            lat: markerPosition.lat,
            lng: markerPosition.lng,
        }

        console.log("params", params);

        try {
            const response = await axios.post(
                GET_ADD_COORDINATES,
                // "http://localhost:8080/api-inv/add-coordinates",
                params,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
                    },
                }
            );
            // console.log("✅ API Response:", response.data);
            if (response?.status === 200) {
                message.success("บันทึกพิกัดสำเร็จ ✅");
                onSave(response.data, params)
            } else {
                api.error({
                    message: 'ไม่สำเร็จ',
                    description: 'บันทึกข้อมูลไม่สำเร็จ',
                    placement: 'top',
                });
            }
        } catch (error) {
            console.error("❌ API Error:", error);
            api.error({
                message: 'เกิดข้อผิดพลาด',
                description: error.message,
                placement: 'top',
            });
        }
    };

    return (
        <Card
            style={{
                // maxWidth: 600,
                margin: "20px auto",
                borderRadius: 10,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                // backgroundColor: "#f5f5f5",
            }}
        >
            <Modal
                open={open} // แก้จาก visible เป็น open (AntD v5+)
                onCancel={handleClose}
                width={900}
                footer={null}
            >

                <Title
                    level={3}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#2c3e50",
                        gap: "10px",
                    }}
                >
                    <EnvironmentOutlined style={{ color: "#1890ff" }} />
                    ที่อยู่ :  {markerName?.province}
                </Title>
                {markerName && (
                    <Descriptions
                        title="รายละเอียดที่ดิน"
                        bordered
                        column={1}
                        size="middle"
                        style={{ marginTop: 16, marginBottom: 8 }}
                    >
                        <Descriptions.Item label="เลขโฉนด">
                            {markerName?.numberLand || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="ระวาง">
                            {markerName?.numberLandlawang || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="จังหวัด">
                            {markerName?.provinceName || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="อำเภอ">
                            {markerName?.districtName || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="ตำบล">
                            {markerName?.subdistrictName || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="รหัสไปรษณีย์">
                            {markerName?.zipcode || "-"}
                        </Descriptions.Item>
                    </Descriptions>
                )}

                {isLoaded &&
                    markerName?.lat &&
                    markerName?.lng ? (
                    <>
                        <Row
                            style={{
                                overflow: "hidden",     // จำเป็นต้องใช้เพื่อให้ขอบมนทำงานกับ Google Map
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // เงาเล็ก ๆ
                                margin: "20px 0",
                            }}
                        >
                            <StyledSearch
                                onSearch={handleSearch}   // กดปุ่ม Enter หรือ "ค้นหา"
                                placeholder="ค้นหาที่อยู่..."
                                enterButton="ค้นหา"
                                style={{ width: "100%" }}
                                autoFocus // เพิ่มตรงนี้
                            />
                        </Row>
                        <Row
                            style={{
                                borderRadius: 20,       // ขอบมน
                                overflow: "hidden",     // จำเป็นต้องใช้เพื่อให้ขอบมนทำงานกับ Google Map
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // เงาเล็ก ๆ
                                margin: "20px 0",
                            }}
                        >
                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={{
                                    lat: markerName?.lat,
                                    lng: markerName?.lng,
                                }}
                                zoom={13}
                                onLoad={(map) => (mapRef.current = map)}
                                onClick={(e) => {
                                    console.log("e  GoogleMap", e);

                                    const lat = e.latLng.lat();
                                    const lng = e.latLng.lng();
                                    setMarkerPosition({ lat, lng });

                                    // อัปเดต markerName ด้วยตำแหน่งใหม่ด้วย (ถ้าต้องการส่งกลับข้อมูล)
                                    setMarkerName((prev) => ({
                                        ...prev,
                                        lat,
                                        lng,
                                    }));
                                    // เรียก Geocoder เพื่อหาชื่อสถานที่
                                    const geocoder = new window.google.maps.Geocoder();
                                    console.log("geocoder", geocoder);

                                    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                        console.log("lat, lng", lat, lng);
                                        console.log("GoogleMap results", results);
                                        console.log("status", status);
                                        mapaddress(lat, lng)
                                        setOptionSelect(results)
                                        if (status === "OK" && results[0]) {
                                            let address = results[0].formatted_address;

                                            // ตัด Plus Code ถ้าอยู่ด้านหน้า
                                            if (address.includes("+")) {
                                                const parts = address.split(","); // แยกด้วย ,
                                                if (parts.length > 1) {
                                                    address = parts.slice(1).join(",").trim(); // เอาส่วนหลัง Plus Code
                                                }
                                            }

                                            setMarkerName((prev) => ({
                                                ...prev,
                                                address, // ✅ จะได้ชื่อสถานที่โดยไม่เอา CMX3+G3
                                            }));
                                        }
                                    });
                                }}
                            >
                                <MarkerF
                                    position={{
                                        lat: markerName?.lat,
                                        lng: markerName?.lng,
                                    }}
                                    title="ตำแหน่ง"
                                    draggable={true} // ✅ ทำให้ลาก marker ได้ด้วย
                                    onDragEnd={(e) => {
                                        console.log("e  MarkerF", e);
                                        const lat = e.latLng.lat();
                                        const lng = e.latLng.lng();

                                        setMarkerPosition({ lat, lng });
                                        setMarkerName((prev) => ({
                                            ...prev,
                                            lat,
                                            lng,
                                        }));
                                        // เรียก Geocoder หลังลาก marker
                                        const geocoder = new window.google.maps.Geocoder();
                                        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                            console.log("MarkerF results", results);
                                            setOptionSelect(results)
                                            if (status === "OK" && results[0]) {
                                                let address = results[0].formatted_address;

                                                // ตัด Plus Code ถ้าอยู่ด้านหน้า
                                                if (address.includes("+")) {
                                                    const parts = address.split(","); // แยกด้วย ,
                                                    if (parts.length > 1) {
                                                        address = parts.slice(1).join(",").trim(); // เอาส่วนหลัง Plus Code
                                                    }
                                                }

                                                setMarkerName((prev) => ({
                                                    ...prev,
                                                    address, // ✅ จะได้ชื่อสถานที่โดยไม่เอา CMX3+G3
                                                }));
                                            }
                                        });

                                    }}
                                />
                            </GoogleMap>
                        </Row>

                        <Row justify={'center'} style={{ margin: 8 }}>
                            <Space>
                                <Button
                                    key="close"
                                    onClick={handleClose}
                                >
                                    ปิด
                                </Button>
                                <Button
                                    key="save"
                                    type="primary"
                                    onClick={handleSave}
                                >
                                    บันทึก
                                </Button>
                            </Space>
                        </Row>
                    </>
                ) : (
                    <div>

                        <Row
                            style={{
                                borderRadius: 20,       // ขอบมน
                                overflow: "hidden",     // จำเป็นต้องใช้เพื่อให้ขอบมนทำงานกับ Google Map
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // เงาเล็ก ๆ
                                margin: "20px 0",
                            }}
                        >
                            <Row
                                style={{
                                    width: '100%',
                                    overflow: "hidden",     // จำเป็นต้องใช้เพื่อให้ขอบมนทำงานกับ Google Map
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // เงาเล็ก ๆ
                                    margin: "20px 0",
                                }}
                            >
                                <StyledSearch
                                    onSearch={handleSearch}   // กดปุ่ม Enter หรือ "ค้นหา"
                                    placeholder="ค้นหาที่อยู่..."
                                    enterButton="ค้นหา"
                                    style={{ width: "100%" }}
                                    autoFocus // เพิ่มตรงนี้
                                />
                            </Row>
                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={
                                    markerName?.lat && markerName?.lng
                                        ? { lat: markerName.lat, lng: markerName.lng } // ใช้ตำแหน่งที่เลือกแล้ว
                                        : defaultCenter // ค่า default (กรุงเทพฯ)
                                }
                                zoom={13}
                                onLoad={(map) => (mapRef.current = map)}
                                onClick={(e) => {
                                    console.log("e  GoogleMap", e);
                                    const lat = e.latLng.lat();
                                    const lng = e.latLng.lng();
                                    setMarkerPosition({ lat, lng });

                                    // อัปเดต markerName ด้วยตำแหน่งใหม่ด้วย (ถ้าต้องการส่งกลับข้อมูล)
                                    setMarkerName((prev) => ({
                                        ...prev,
                                        lat,
                                        lng,
                                    }));
                                    // เรียก Geocoder เพื่อหาชื่อสถานที่
                                    const geocoder = new window.google.maps.Geocoder();
                                    console.log("geocoder", geocoder);

                                    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                        console.log("lat, lng", lat, lng);
                                        console.log("GoogleMap results", results);
                                        console.log("status", status);
                                        mapaddress(lat, lng)
                                        setOptionSelect(results)
                                        if (status === "OK" && results[0]) {
                                            let address = results[0].formatted_address;

                                            // ตัด Plus Code ถ้าอยู่ด้านหน้า
                                            if (address.includes("+")) {
                                                const parts = address.split(","); // แยกด้วย ,
                                                if (parts.length > 1) {
                                                    address = parts.slice(1).join(",").trim(); // เอาส่วนหลัง Plus Code
                                                }
                                            }

                                            setMarkerName((prev) => ({
                                                ...prev,
                                                address, // ✅ จะได้ชื่อสถานที่โดยไม่เอา CMX3+G3
                                            }));
                                        }
                                    });
                                }}
                            >
                                {markerName?.lat && markerName?.lng && (
                                    <MarkerF
                                        position={{
                                            lat: markerName.lat,
                                            lng: markerName.lng,
                                        }}
                                        title="ตำแหน่ง"
                                        draggable={true}
                                        onDragEnd={(e) => {
                                            const lat = e.latLng.lat();
                                            const lng = e.latLng.lng();

                                            setMarkerPosition({ lat, lng });
                                            setMarkerName((prev) => ({
                                                ...prev,
                                                lat,
                                                lng,
                                            }));

                                            const geocoder = new window.google.maps.Geocoder();
                                            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                                if (status === "OK" && results[0]) {
                                                    let address = results[0].formatted_address;
                                                    if (address.includes("+")) {
                                                        const parts = address.split(",");
                                                        if (parts.length > 1) {
                                                            address = parts.slice(1).join(",").trim();
                                                        }
                                                    }
                                                    setMarkerName((prev) => ({
                                                        ...prev,
                                                        address,
                                                    }));
                                                    setOptionSelect(results);
                                                }
                                            });
                                        }}
                                    />
                                )}
                            </GoogleMap>
                        </Row>
                    </div>
                )}
            </Modal>
            {contextHolder}
        </Card>
    );
}

export default Map;
